import { Dialog, DialogContent, DialogActions, Button } from '@mui/material';
import { useLogout } from 'hooks';

export interface ContactSupportAccountCreationDialogProps {
    open: boolean;
    setOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

export const ContactSupportAccountCreationDialog = ({
    open,
    setOpen,
}: ContactSupportAccountCreationDialogProps) => {
    const logout = useLogout();

    const handleClose = () => {
        setOpen(false);
        logout();
    };

    return (
        <Dialog
            data-testid="ContactSupportAccountCreationDialog"
            open={open}
            maxWidth="sm"
            fullWidth
            onClose={handleClose}
        >
            <DialogContent>
                Thanks for signing up! Please contact support@tankutility.com to
                finish setting up your account.
            </DialogContent>

            <DialogActions>
                <Button variant="contained" onClick={handleClose}>
                    Got it!
                </Button>
            </DialogActions>
        </Dialog>
    );
};
